import script from "./ShortcutGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./ShortcutGuide.vue?vue&type=script&setup=true&lang=js"

import "./ShortcutGuide.vue?vue&type=style&index=0&id=28fc2763&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28fc2763"]])

export default __exports__